import styles from './app.module.scss';
import Navigator from '../../components/prefabs/navigator/navigator';
import { useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../../contexts/projectContext';
import { UserContext } from '../../contexts/userContext';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { localStorageService, STORAGE_KEY } from '../../services/local-storage.service';
import Header from '../../components/prefabs/header/header';
import { WCircularProgress, WStack } from '../../components/wrappers/wrapper';
import InformativeTitle from '../../components/prefabs/channel-bar/channel-bar';
import helperService from '../../services/helper.service';
import { CommonContext } from 'contexts/commonContext';
import useDeviceType from 'custom-hooks/useDeviceType';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDesktop } = useDeviceType();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const { projectData } = useContext(ProjectContext);
  const { currentPage } = useContext(UserContext);
  const { showMenu, setShowMenu } = useContext(CommonContext);

  const [showNav, setShowNav] = useState(false);
  const [loading, setLoading] = useState(true);

  const getLogo = () => {
    if (projectData?.project_logo) {
      return projectData?.project_logo;
    }
    return '...';
  };

  useEffect(() => {
    if (urlParams.get('data')) {
      const receivedValue = JSON.parse(urlParams.get('data')!);
      localStorageService.setItem(STORAGE_KEY.TOKEN, JSON.stringify(receivedValue!.token));
    }
  }, []);

  useEffect(() => {
    const title = projectData?.title || process.env.REACT_APP_DOCUMENT_TITLE;

    document.title = helperService.capitalizeFirstLowercaseRest(currentPage.title) + ' | ' + title;
  }, [currentPage.title]);

  useEffect(() => {
    const link = document.querySelector('link[rel="icon"]');

    if (link) {
      link.setAttribute('href', getLogo());
    }

    if (location.pathname === '/') {
      navigate('/home');
    }
  });

  useEffect(() => {
    if (showMenu) {
      setShowNav(true);
      return;
    }

    setTimeout(() => {
      setShowNav(false);
    }, 300);
  }, [showMenu]);

  useEffect(() => {
    if (!projectData) return;
    setLoading(false);
  }, [projectData]);

  function handleOverlayClick() {
    if (showMenu) {
      setShowMenu(false);
    }
  }

  return (
    <div className={`${styles.app} ${loading && styles.loading}`}>
      {loading ? (
        <WCircularProgress size={24} />
      ) : (
        <>
          {showNav && <Navigator className={styles.navMobile} />}
          <div
            className={`${styles.content} ${showMenu && styles.showMenu}`}
            onClick={handleOverlayClick}
          >
            <Header />
            <WStack direction="row">
              {isDesktop && <Navigator className={styles.navDesktop} />}
              <WStack className={styles.container}>
                <InformativeTitle />
                <div className={styles.outlet}>
                  <Outlet />
                </div>
              </WStack>
            </WStack>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
